<script>
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import groupBy from "lodash/groupBy";
export default {
  props: {
    budgetline: {},
    tableBusy: null,
  },
  components: {
    OfficeBudgetTransaction: () =>
      import("@/components/tables/officebudgettransactions.vue"),
    MaskedInput,
  },
  data() {
    return {
      alert: {
        type: null,
        message: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortDesc: false,
      transactionModal: false,
      revertModal: false,
      fundModal: false,
      office: null,
      budgetLineItem: null,
      officeBudgetTransaction: [],
      revertOptions: [
        { value: "fs", text: "Fund Source" },
        { value: "oe", text: "Object of Expenditure" },
      ],
      selectedOfficeBudget: null,
      transaction: {
        deliveryUnitBudgetItemId: null,
        amount: "0",
      },
      budgetTransaction: {
        deliveryUnitBudgetItemId: null,
        amount: "0",
        date: null,
        description: null,
      },
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      selectedRevertOption: null,
      selectedBLI: null,
      submitted: false,
      selectedToBePosted: [],
      clickedSelected: false,
    };
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    async viewTransaction(item) {
      const { data } = await this.$store.dispatch(
        "officebudgetitem/GetOfficeBudgetItemTransaction",
        item.id
      );
      this.officeBudgetTransaction = data;
      this.transactionModal = true;
    },
    postBudgetItem(item) {
      this.$swal({
        title: "Are you sure you want to post this budget item?",
        html: `Once posted, you will not be able to edit this budget item. You have allocated <span class="text-warning">${this.formatCurrency(
          item.allocated
        )}</span> to <span class="text-info">${item.deliveryUnit.name}</span>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, post it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("post", item);
        }
      });
    },
    revert(item) {
      if (item.unUsed < 1) {
        this.$swal({
          title: "Oops! Something went wrong",
          text: "Cannot revert this budget item. There are no unused funds to revert.",
          icon: "error",
        });
        return;
      }
      this.selectedOfficeBudget = item;
      this.transaction.deliveryUnitBudgetItemId = item.id;
      this.transaction.amount = item.unUsed.toString();
      this.revertModal = true;
    },
    toggleRevertOption(item) {
      this.selectedRevertOption = item;
    },
    saveRevert() {
      const trans = JSON.parse(JSON.stringify(this.transaction));
      if (
        Number(this.getExactAmt(trans.amount)) < 0 ||
        this.selectedRevertOption === null
      ) {
        this.alert = {
          type: "danger",
          message: "Please fill up all required fields.",
        };
        return;
      }
      if (Number(this.getExactAmt(trans.amount)) < 1) {
        this.alert = {
          type: "danger",
          message: "Amount cannot be less than to 1",
        };
        return;
      }
      if (Number(this.getExactAmt(trans.amount)) > this.selectedOfficeBudget.unUsed) {
        this.alert = {
          type: "danger",
          message:
            "The amount you entered is greater than the balance of the budget item.",
        };
        return false;
      }
      // this.transaction.amount = Number(this.transaction.amount);
      trans.amount = Number(this.getExactAmt(trans.amount));
      const data = {
        transaction: trans,
        revertOption: this.selectedRevertOption,
      };
      this.$store.dispatch("officebudgetitem/revertFunds", data).then((response) => {
        this.budgetline.find(
          (item) => item.id === this.transaction.deliveryUnitBudgetItemId
        ).unUsed -= trans.amount;
        this.budgetline.find(
          (item) => item.id === this.transaction.deliveryUnitBudgetItemId
        ).fundBalance -= trans.amount;
        this.revertModal = false;
        this.alert.type = null;
        this.alert.message = null;
        this.transaction.amount = "0";
        this.$swal({
          title: "Success!",
          text: response.data,
          icon: "success",
        });
      });
    },
    async addBuget(record) {
      const { data } = await this.$store.dispatch(
        "objectOfExpenditures/getSingleObjectOfExpenditures",
        record.objectOfExpenditureId
      );
      this.selectedBLI = data;
      this.budgetTransaction.deliveryUnitBudgetItemId = record.id;
      // this.budgetTransaction.budgetLineItemId = record.budgetLineItemId;

      this.fundModal = true;
    },
    saveFund() {
      const deliveryUnit = JSON.parse(JSON.stringify(this.budgetTransaction));
      if (Number(this.getExactAmt(deliveryUnit.amount)) < 1) {
        this.alert = {
          type: "danger",
          message: "Amount cannot be less than 1.",
        };
        return;
      }
      if (Number(this.getExactAmt(deliveryUnit.amount)) > this.selectedBLI.balance) {
        this.alert = {
          type: "danger",
          message:
            "The amount you entered is greater than the balance of the object expenditure.",
        };
        return false;
      }

      deliveryUnit.amount = Number(this.getExactAmt(this.budgetTransaction.amount));
      deliveryUnit.date = new Date().toISOString();
      /** debit to deliveryBudgetItem */

      deliveryUnit.description = "Addition of funds from object of Expenditure";

      try {
        const response = this.$store.dispatch("officebudgetitem/CreateOfficeBudgetItemTransaction", deliveryUnit);
        console.log(response);
        this.budgetline.find((item) => item.id === this.budgetTransaction.deliveryUnitBudgetItemId).allocated += deliveryUnit.amount;
        this.budgetline.find((item) => item.id === this.budgetTransaction.deliveryUnitBudgetItemId).fundBalance += deliveryUnit.amount;
        this.budgetline.find((item) => item.id === this.budgetTransaction.deliveryUnitBudgetItemId).unUsed += deliveryUnit.amount;
        this.showToast("Funds successfully added to delivery unit budget line item", "success")
        this.budgetTransaction.amount = "0";
      } catch (e) {
        this.$swal({
          title: "Error",
          text: e.message,
          icon: "error",
        });
      }

      this.fundModal = false;
    },
    print(id) {
      this.$emit("print", id);
    },
    deleteBudgetItem(record) {
      if (record.unUsed > 0) {
        this.$swal({
          title: "Oops! Something went wrong",
          text:
            "Cannot delete budget item with allocated funds. Make sure to revert all funds first before removing this record",
          icon: "error",
        });
        return;
      }
      this.$swal({
        title: "Are you sure you want to delete this budget item?",
        text: "Once deleted, you will not be able to edit this budget item.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("delete", record);
          // this.tableBusy = false;
        }
      });
    },
    updateBudgetItem(record) {
      this.$emit("update", record);
    },
    filterTable(row, filter) {
      if (
        row.objectOfExpenditure.prexc.prexcName.toLowerCase().includes(filter) ||
        row.objectOfExpenditure.accountGroup.groupName.toLowerCase().includes(filter)
      ) {
        return true;
      } else {
        return false;
      }
    },
    selectAllBudgetItems() {
      this.clickedSelected = !this.clickedSelected;
      if (this.clickedSelected) {
        this.filteredBudget.forEach((fundSource) => {
          fundSource.data.forEach((classification) => {
            classification.data.forEach((item) => {
              item.isSelected = true;
            });
          });
        });
      } else {
        this.filteredBudget.forEach((fundSource) => {
          fundSource.data.forEach((classification) => {
            classification.data.forEach((item) => {
              item.isSelected = false;
            });
          });
        });
      }
    },
    postBudgetItems() {
      this.selectedToBePosted = [];
      this.filteredBudget.forEach((fundSource) => {
        fundSource.data.forEach((classification) => {
          classification.data.forEach((item) => {
            if (item.isSelected) {
              this.selectedToBePosted.push(item.id);
            }
          });
        });
      });
      if (this.selectedToBePosted.length === 0) {
        this.$swal({
          title: "Oops! Something went wrong",
          text: "No budget items selected",
          icon: "error",
        });
        return;
      }
      this.$swal({
        title: "Are you sure you want to post these budget items?",
        html: `Once posted, you will not be able to edit this budget item.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, post it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("postItems", this.selectedToBePosted);
        }
      });
    },
  },
  computed: {
    rows() {
      return this.budgetline.length;
    },
    filteredBudget() {
      let data = this.budgetline;
      // var total = this.currentPage * this.perPage;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.objectOfExpenditure.accountGroup.groupName
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      // var currentData = data.slice(total - this.perPage, total);
      // if (this.currentPageB > 1 && currentData.length == 0) {
      //   total = (this.currentPage - 1) * this.perPage;
      //   currentData = data.slice(total - this.perPage, total);
      // }
      var groupedFS = groupBy(data, "fundSource");
      var grouped = [];
      var id = 1;
      var FCID = 1;
      for (const key in groupedFS) {
        var sumBalance = 0;
        var sumAllocated = 0;
        var sumUsed = 0;
        var group = groupBy(groupedFS[key], "fundClass");
        groupedFS[key].forEach((a) => {
          sumBalance += a.balance;
          sumAllocated += a.allocated;
          sumUsed += a.totalWithInflation;
        });
        var FC = [];
        for (const y in group) {
          FC.push({
            id: FCID++,
            data: group[y],
            key: y,
          });
        }
        grouped.push({
          id: id++,
          fsName: key,
          balance: sumBalance,
          allocated: sumAllocated,
          used: sumUsed,
          data: FC,
          fsId: FC[0].data[0].objectOfExpenditure.fundSourceId,
        });
      }
      return grouped;
    },
  },
  created() {},
};
</script>
<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-md-6 d-flex">
        <div id="tickets-table_filter" class="dataTables_filter me-1">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search Budget..."
              class="form-control"
            ></b-form-input>
          </label>
        </div>
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center mb-0">
            <b-form-select
              class="form-select"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
          </label>
        </div>
      </div>
      <div class="col-md-6 text-start text-md-end">
        <b-button
          size="sm"
          class="mt-1 me-2"
          variant="purple"
          v-if="budgetline.length > 1"
          @click="selectAllBudgetItems"
        >
          <i class="bx bx-check align-middle me-1"></i>
          {{ clickedSelected ? "Unselect All" : "Select All" }}
        </b-button>
        <b-button
          size="sm"
          variant="success"
          class="mt-1"
          v-if="budgetline.length > 1"
          @click="postBudgetItems"
        >
          <i class="bx bx-upload align-middle me-1"></i>
          Post Selected
        </b-button>
      </div>
    </div>
    <div>
      <div class="custom-table-responsive">
        <table
          class="table project-list-table table-centered table-borderless align-middle"
        >
          <thead>
            <tr>
              <th scope="col" width="50px"></th>
              <th scope="col">Description</th>
              <th scope="col" width="250px" class="text-center">Budget</th>
              <th scope="col" width="230px" class="text-center">Validity</th>
              <th scope="col" width="230px" class="text-center">Status</th>
              <th scope="col" width="90px" class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="tableBusy">
              <td colspan="6">
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </td>
            </tr>
            <template v-for="y in filteredBudget">
              <tr
                :key="'A' + y.id"
                style="background-color: transparent; box-shadow: none"
              >
                <td colspan="6" class="py-0">
                  <div class="d-flex align-items-center">
                    <span
                      class="bx bx-star text-warning me-1"
                      style="line-height: unset"
                    ></span>
                    <h5 class="text-warning mb-0 me-2">
                      {{ y.fsName }}
                    </h5>
                  </div>
                </td>
              </tr>
              <template v-for="z in y.data">
                <tr
                  :key="'B' + z.id"
                  style="background-color: transparent; box-shadow: none"
                >
                  <td colspan="6" class="p-0-20p">
                    <div class="d-flex align-item-center">
                      <span
                        class="bx bx-checkbox-square text-success me-1"
                        style="line-height: unset"
                      ></span>
                      <b class="text-info">{{ z.key }}</b>
                    </div>
                  </td>
                </tr>
                <tr
                  v-for="x in z.data"
                  :key="x.id"
                  style="background-color: transparent; box-shadow: none"
                >
                  <td class="text-right">
                    <b-form-checkbox
                      v-model="x.isSelected"
                      v-if="x.status.toLowerCase() === 'pending'"
                    ></b-form-checkbox>
                  </td>
                  <td class="bg-table-tr">
                    <h5 class="text-truncate font-size-14 mb-0 d-flex">
                      {{ x.objectOfExpenditure.accountGroup.groupName }}
                      <div>
                        <span
                          class="badge rounded-pill bg-danger float-end"
                          style="font-size: 8px"
                          >{{ x.notification > 0 ? x.notification : "" }}</span
                        >
                      </div>
                    </h5>
                    <p class="mb-0">
                      <span
                        class="badge rounded-pill bg-success font-size-12"
                        v-if="x.forCharging"
                        >Centrally-managed Items</span
                      >
                    </p>
                  </td>
                  <td class="bg-table-tr text-center">
                    <div class="row">
                      <div class="col-sm-6 pe-1 me-0 text-end">Allocated:</div>
                      <div class="col-sm-6 ps-0 text-start">
                        <span class="text-info">{{ formatCurrency(x.allocated) }}</span>
                      </div>
                      <div class="col-sm-6 pe-1 me-0 text-end">Fund Balance:</div>
                      <div class="col-sm-6 ps-0 text-start">
                        <span class="text-warning">{{
                          formatCurrency(x.fundBalance)
                        }}</span>
                      </div>
                      <div class="col-sm-6 pe-1 me-0 text-end">Unused:</div>
                      <div class="col-sm-6 ps-0 text-start">
                        <span class="text-warning">{{ formatCurrency(x.unUsed) }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="bg-table-tr text-center">
                    <span
                      class="ms-2 badge rounded-pill font-size-11"
                      :class="{
                        'badge-soft-success': checkExpiry(x.expiry),
                        'bg-danger': !checkExpiry(x.expiry),
                      }"
                    >
                      <!-- {{ checkExpiry(x.expiry) ? "Expiry:" : "Expired:" }} -->
                      {{ formatDate(x.expiry) }}</span
                    >
                  </td>
                  <td class="bg-table-tr text-center">
                    <span
                      :class="{
                        'text-info': x.status.toUpperCase() === 'POSTED',
                        'text-warning': x.status.toUpperCase() === 'PENDING',
                      }"
                      >{{ x.status }}</span
                    >
                  </td>
                  <td class="text-center bg-table-tr text-center">
                    <div class="d-flex justify-content-center">
                      <b-button variant="link" size="sm" :id="`popover-target-${x.id}`">
                        <i class="fas fa-ellipsis-h"></i>
                      </b-button>
                      <b-popover
                        :target="`popover-target-${x.id}`"
                        id="menu"
                        triggers="hover blur"
                        placement="leftbottom"
                        custom-class="p-0 p-custom-class"
                      >
                        <b-list-group class="w-100 fit">
                          <b-list-group-item button action @click="addBuget(x)">
                            <i class="bx bx-money align-middle me-2 font-size-16"></i>
                            <span class="align-middle">Add Budget</span>
                          </b-list-group-item>

                          <b-list-group-item button action @click="viewTransaction(x)">
                            <i class="bx bx-list-ol align-middle me-2 font-size-16"></i>
                            <span class="align-middle">View Transactions</span>
                          </b-list-group-item>

                          <b-list-group-item
                            button
                            action
                            @click="print(x.id)"
                            v-if="x.status.toLowerCase() === 'posted'"
                          >
                            <i class="bx bx-list-ol align-middle me-2 font-size-16"></i>
                            <span class="align-middle">Print RAOS</span>
                          </b-list-group-item>

                          <b-list-group-item button action @click="updateBudgetItem(x)">
                            <i
                              class="bx bx-edit align-middle me-2 font-size-16 text-warning"
                            ></i>
                            <span class="align-middle">Edit</span>
                          </b-list-group-item>

                          <b-list-group-item
                            button
                            action
                            @click="deleteBudgetItem(x)"
                            v-if="x.status.toLowerCase() !== 'posted'"
                          >
                            <i
                              class="bx bx-trash align-middle me-2 font-size-16 text-danger"
                            ></i>
                            <span class="align-middle">Delete</span>
                          </b-list-group-item>

                          <b-list-group-item
                            button
                            action
                            @click="postBudgetItem(x)"
                            v-if="x.status.toLowerCase() !== 'posted'"
                          >
                            <i
                              class="bx bx-check align-middle me-2 font-size-16 text-success"
                            ></i>
                            <span class="align-middle">Post</span>
                          </b-list-group-item>

                          <b-list-group-item button action @click="revert(x)">
                            <i
                              class="bx bx-undo align-middle me-2 font-size-16 text-danger"
                            ></i>
                            <span class="align-middle">Revert</span>
                          </b-list-group-item>
                        </b-list-group>
                      </b-popover>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
      <!-- <div class="row mb-3">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
    <b-modal
      v-model="transactionModal"
      title="Account Information"
      size="xl"
      title-class="font-18"
      hide-footer
    >
      <OfficeBudgetTransaction
        v-if="officeBudgetTransaction.length > 0"
        :transactions="officeBudgetTransaction"
      >
      </OfficeBudgetTransaction>
    </b-modal>
    <!-- Revert modal -->
    <b-modal v-model="revertModal" title="Revert funds" title-class="font-18" hide-footer>
      <b-alert
        :show="alert.type === 'danger'"
        dismissible
        @dismissed="alert.type = ''"
        variant="danger"
      >
        <i class="mdi mdi-alert-outline me-2"></i>{{ alert.message }}
      </b-alert>
      <p class="mb-1">
        <strong>Fund Source: </strong>
        <span class="text-success">
          {{selectedOfficeBudget ? selectedOfficeBudget.objectOfExpenditure.fundSource.sourceName : ""}}
        </span>
      </p>
      <!-- <p class="mb-1">
        <strong>PREXC: </strong>
        <span class="text-success">
          {{selectedOfficeBudget ? selectedOfficeBudget.objectOfExpenditure.prexc.prexcName : ""}}
        </span>
      </p> -->
      <p class="mb-3">
        <strong>Object of Expenditure: </strong>
          <span class="text-success">
            {{selectedOfficeBudget ? selectedOfficeBudget.objectOfExpenditure.accountGroup.groupName : ""}}
          </span>
      </p>
      <hr />
      <div class="mb-3">
        <label>Select Destination</label>
        <b-form-select
          class="form-select form-select-sm"
          size="sm"
          :options="revertOptions"
          @change="toggleRevertOption"
        >
        </b-form-select>
      </div>
      <div class="mb-3">
        <label>Amount</label>
        <!-- <b-form-input v-model.number="transaction.amount" type="number"> </b-form-input> -->
        <masked-input
          autocomplete="off"
          type="text"
          v-model="transaction.amount"
          placeholder="Enter Amount..."
          class="form-control"
          :mask="currencyMask"
        ></masked-input>
      </div>
      <div class="modal-footer">
        <b-button variant="primary" @click="saveRevert">Revert now</b-button>
        <b-button variant="link" @click="revertModal = !revertModal">Close</b-button>
      </div>
    </b-modal>
    <!-- Add Budget modal -->
    <b-modal title="Add Budget" v-model="fundModal" title-class="font-18" hide-footer>
      <b-alert
        :show="alert.type === 'danger'"
        dismissible
        @dismissed="alert.type = ''"
        variant="danger"
      >
        <i class="mdi mdi-alert-outline me-2"></i>{{ alert.message }}
      </b-alert>
      <p class="mb-1">
        <span>Object of Expenditure: </span>
        <strong class="text-info">{{selectedBLI ? `${selectedBLI.accountGroup.groupName}`: ""}}</strong>
      </p>
      <p class="mb-3">
        <span>Balance: </span>
        <strong class="text-info">{{selectedBLI ? formatCurrency(selectedBLI.balance) : ""}}</strong>
      </p>
      <div class="mb-3">
        <label>Amount</label>
        <masked-input
          autocomplete="off"
          type="text"
          v-model="budgetTransaction.amount"
          placeholder="Enter Amount..."
          class="form-control"
          :mask="currencyMask"
        ></masked-input>
      </div>
      <div class="modal-footer">
        <b-button variant="primary" @click="saveFund">Add</b-button>
        <b-button variant="link" @click="fundModal = !fundModal">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
